import { useState } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { colors } from "@/theme";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Logo";
import { GoogleButton } from "@/components/GoogleAuth";
import { toast } from "sonner";

export default function Login() {
  const [identifier, setIdentifier] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await login(identifier.trim(), password);
      toast.success(`Welcome back, ${u.name.split(" ")[0]}`);
      const dest = location.state?.from || (u.role === "admin" ? "/admin" : "/");
      navigate(dest, { replace: true });
    } catch (err) {
      toast.error(err.message || "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div style={{ minHeight: "80vh", display: "flex", alignItems: "center", padding: "48px 24px" }}>
      <div className="form-narrow fade-up">
        <div style={{ textAlign: "center", marginBottom: 32 }}>
          <Logo size={30} />
        </div>
        <h1 className="font-display" style={{ fontSize: 34, fontWeight: 700, margin: 0, textAlign: "center" }}>Welcome back</h1>
        <p className="font-body" style={{ textAlign: "center", color: colors.mutedText, marginTop: 8, marginBottom: 28 }}>Sign in to continue shopping</p>
        <form onSubmit={submit} style={{ display: "flex", flexDirection: "column", gap: 16 }}>
          <div>
            <label className="eyebrow" style={{ display: "block", marginBottom: 8 }}>Email or Mobile</label>
            <input data-testid="login-identifier" className="input-field" value={identifier} onChange={(e) => setIdentifier(e.target.value)} placeholder="you@example.com" required />
          </div>
          <div>
            <label className="eyebrow" style={{ display: "block", marginBottom: 8 }}>Password</label>
            <input data-testid="login-password" className="input-field" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" required />
          </div>
          <button data-testid="login-submit" className="btn-primary" type="submit" disabled={busy} style={{ marginTop: 8 }}>
            {busy ? "Signing in…" : "Sign In"}
          </button>
        </form>
        <div style={{ display: "flex", alignItems: "center", gap: 12, margin: "22px 0" }}>
          <div style={{ flex: 1, height: 1, background: colors.border }} />
          <span className="eyebrow">or</span>
          <div style={{ flex: 1, height: 1, background: colors.border }} />
        </div>
        <GoogleButton />
        <p className="font-body" style={{ textAlign: "center", marginTop: 24, fontSize: 14, color: colors.mutedText }}>
          New here? <Link data-testid="go-signup" to="/signup" style={{ color: colors.brand, fontWeight: 600 }}>Create an account</Link>
        </p>
      </div>
    </div>
  );
}
